"use strict";
/**
 * Shared constants for the UseCaseAlignment feature.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALIGNMENT_ERROR_BORDER_COLOR = exports.ALIGNMENT_DROPDOWN_WIDTH = void 0;
/** Width of header dropdowns, in pixels. */
exports.ALIGNMENT_DROPDOWN_WIDTH = 300;
/** Fabric semantic-error red used to flag missing required selections. */
exports.ALIGNMENT_ERROR_BORDER_COLOR = "#a4262c";
